import _arrayLikeToArray from './arrayLikeToArray.js';

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

export { _arrayWithoutHoles as default };
